import { ReactComponent as StatusIcon } from '@assets/components/panel/monitoring/status.svg';
import { CheckboxFilterItem } from '@components/cockpit/panels/CheckboxListFilter';
import { sensorStatusColor } from '@utils/sensors/configuration.constants';

import { SensorInstallationStatusEnum } from '@/types/filters.types';

export const getInstallationStatusItems = (
  isChecked: (status: SensorInstallationStatusEnum) => boolean | undefined,
  onChange: (status: SensorInstallationStatusEnum) => void,
  filteredSensorsWithoutStatusLength: number,
): CheckboxFilterItem[] =>
  Object.values(SensorInstallationStatusEnum).map((status) => ({
    label: `components.sensorInstallation.filters.sensors.sensorInstallationStatus.${status}`,
    checked: isChecked(status),
    disabled: status === SensorInstallationStatusEnum.DRAFT,
    icon: StatusIcon,
    iconColor: sensorStatusColor[status],
    count: status === SensorInstallationStatusEnum.DRAFT ? 0 : filteredSensorsWithoutStatusLength,
    onChange: () => onChange(status),
  }));
